"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var hero_module_1 = __importDefault(require("../../../modules/hero/hero.module"));
var index_1 = __importDefault(require("./content/index"));
var index_2 = __importDefault(require("../../landing/fans/sections/getStarted/index"));
var i18next_1 = require("i18next");
function StarsFitness() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hero_module_1.default, { style: {
                    backgroundImage: "url(\"/assets/images/stars/bghealth.png\")",
                }, title: (0, i18next_1.t)("starsFitness.title") }), (0, jsx_runtime_1.jsx)(index_1.default, {}), (0, jsx_runtime_1.jsx)(index_2.default, {})] }));
}
exports.default = StarsFitness;
